export default __webpack_public_path__ + "static/02-4de3b1b7e32477f14aca4894e086f21c.jpg";